import { render, staticRenderFns } from "./MarketingEmail.vue?vue&type=template&id=21fcda43&lang=pug"
import script from "./MarketingEmail.vue?vue&type=script&lang=js"
export * from "./MarketingEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports